import { React, useEffect, useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
import Loading from '../assets/images/icon-loading1.gif';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
function LoadingDefault(prop) {

    //LoadingPage
    const [flagDisplay, SetFlagDisplay] = useState(true)

    useEffect(() => {


        if (prop?.flag === 1) {

            SetFlagDisplay(true);


        } else {
            SetFlagDisplay(false);

        }

    }, [prop?.flag]);

    return (
        <>
            {/*<div style={{ display: flagDisplay === true ? "block" : 'none' }}>*/}
            {/*<Fade in={flagDisplay} sx={{ display: 'flex' }} timeout={200}>*/}
            <div id="div-loading-default" className='flex justify-center items-center div-loading-block ' style={{ background: "#fff", position: "fixed", top: "0px", left: "0px", width: "100vw" }} >

                <div className="flex">
                    <div   >  <img src={Loading} />
                        <div className="text-loading"> Loading... </div>
                    </div>



                </div>
                {/*<Spinner animation="border" role="status" style={{ color: "#4d4949" }} className="flex justify-center items-center " />*/}
            </div>
            {/*</Fade>*/}

        </>
    );

} export default LoadingDefault;


